<div class='spinner-loader' *ngIf="loaderShow">
    <div class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>

</div>